/**
 * Rule to check if the value is a file
 */
export default {
    name     : 'file',
    validate : (value, data, parameters) => parameters?.[0] === undefined
        ? value instanceof File
        : (value instanceof File || typeof value === 'string'),
    message  : field => `The field ${field} must be a file`
}